import React, { memo, useState } from "react";
import CoolbizAuthHeader from "./CoolbizAuthHeader";
import CoolbizAuthNavbar from "./CoolbizAuthNavbar";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ConnectGoHighLevelCode from "../components/connectGoHighLevel/ConnectGoHighLevelCode";

const variants = {
  initial: { opacity: 0, y: 10 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.3, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    y: -10,
    scale: 0.98,
    transition: { duration: 0.3, ease: "easeIn" },
  },
};

const RouteTransition = ({ children }) => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname} // key ensures animation on route change
        initial="initial"
        animate="animate"
        exit="exit"
        variants={variants}
        style={{ width: "100%", height: "100%" }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

const AuthLayout = ({ children }) => {
  const [navToggle, setNavToggle] = useState(false);

  return (
    <React.Fragment>
      <div id="window">
        <section className="body-wrap dashboard-body_wrap">
          <div className="container larg">
            <section className="dashboard-wrap">
              <CoolbizAuthNavbar
                navToggle={navToggle}
                setNavToggle={setNavToggle}
              />
              <div
                className="dashboard-right"
                onClick={() => navToggle && setNavToggle(false)}
              >
                <CoolbizAuthHeader setNavToggle={setNavToggle} />
                <div className="pl-30">
                  {/* {<ConnectGoHighLevelCode />} */}
                  <RouteTransition>{children}</RouteTransition>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default memo(AuthLayout);
